// extracted by mini-css-extract-plugin
export default {"partnersList":"partners_partnersList__-6McD","partnersItem":"partners_partnersItem__6mC-l"};